import { api as tempApi } from "../reducers/actions/apiActions";
import { genericAction } from "../reducers/actions/genericActions";
import { TemplateUIObject, TemplateSTATEObject, TemplateTEMPObject } from "@services/storage/storeTemplate";

export const ui = genericAction("ui") as TemplateUIObject;
export const api = tempApi();
export const state = genericAction("state") as TemplateSTATEObject;
export const temp = genericAction("temp") as TemplateTEMPObject;
